export default __webpack_public_path__ + "static/media/chime.6f1738d7.mp3";